// extracted by mini-css-extract-plugin
export default {"container":"FrequencyList_container__DUWRz","actions":"FrequencyList_actions__S2dI1"};